import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { filter as _filter, findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';

import Modal from 'components/Modal';
import List from 'components/List';

class HandoverDetails extends React.Component {
  listDamages = side => {
    const {
      intl: { messages },
      handover,
    } = this.props;

    const damages = _filter(handover.data.damages, ['side', side]);

    if (damages.length) {
      return [
        <dt class="m-t-5" key={'damageTitle' + side}>
          {messages.damages}: {messages.handover_damage[side]}
        </dt>,
        <dd key={'damagesList' + side}>
          {damages.map((damage, i) => {
            return (
              <div key={i}>
                {i + 1}. {damage.note}
              </div>
            );
          })}
        </dd>,
      ];
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      show,
      close,
      handover,
      handoverAttributes,
    } = this.props;

    const item = handover.data.item ? handover.data.item : {};

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.handover} {item.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {handoverAttributes.pending ? (
            <Loader />
          ) : (
            <div>
              <dl>
                <dt>{messages.filled_out_by}</dt>
                <dd>{handover.data.creator.name}</dd>

                <dt class="m-t-5">{messages.filled_out_on}</dt>
                <dd>
                  <IntlDate date={handover.data.cdate} />
                </dd>

                <dt class="m-t-5">{messages.difficulties}</dt>
                <dd>{handover.data.difficulties ? messages[handover.data.difficulties] : '-'}</dd>

                <dt class="m-t-5">{messages.mileage}</dt>
                <dd>
                  {handover.data.mileage} {messages.mileage_unit}
                </dd>

                <dt class="m-t-5">{messages.fuel_level}</dt>
                <dd>{handover.data.fuel_level}%</dd>

                {handoverAttributes.data.list.map((handoverAttribute, i) => {
                  const isChecked = _findIndex(handover.data.attributes, ['id', handoverAttribute.id]) > -1;

                  return [
                    <dt class="m-t-5" key={'title' + i}>
                      {getNameInCurrentLanguage(handoverAttribute.name, appIntl)}
                    </dt>,
                    <dd key={i}>
                      {isChecked ? <i class="fal fa-check text-success" /> : <i class="fal fa-times text-danger" />}
                    </dd>,
                  ];
                })}

                {this.listDamages('front')}
                {this.listDamages('back')}
                {this.listDamages('left')}
                {this.listDamages('right')}
                {this.listDamages('top')}
                {this.listDamages('interior')}
              </dl>
            </div>
          )}
        </Modal.Body>

        <List
          noRender
          listName="handoverAttributes"
          url={'/api/handovers/' + handover.data.lead_id + '/' + item.id + '/attributes.json'}
          list={handoverAttributes}
        />
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    handoverAttributes: state.list.handoverAttributes,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(HandoverDetails)));
